<template>
  <div class="VuePagination row col-md-12 ">
    <nav>
      <ul class="pagination VuePagination__pagination">
        <li
          class="VuePagination__pagination-item page-item"
          :class="{'disabled': isOnFirstPage}"
          @click.prevent="setPage(currentPage - 1)"
        >
          <a
            href="javascript:void(0);"
            class="page-link prev-next-btn"
          >&lt;</a>
        </li>
        <li
          class="VuePagination__pagination-item page-item"
          v-for="page in pages"
          :class="{'active': page === currentPage}"
          @click.prevent="setPage(page)"
        >
          <a
            href="javascript:void(0)"
            role="button"
            class="page-link"
          >{{ page }}</a>
        </li>
        <li
          class="VuePagination__pagination-item page-item"
          :class="{'disabled': isOnLastPage}"
          @click.prevent="setPage(currentPage + 1)"
        >
          <a
            href="javascript:void(0);"
            class="page-link prev-next-btn"
          >&gt;</a>
        </li>
      </ul>
      <p
        class="VuePagination__count text-left col-md-12"
      >
        {{ totalRecords ? `${formatNumberWithCommas(from)} - ${formatNumberWithCommas(to)} / ${formatNumberWithCommas(totalRecords)} 件` : '' }}
      </p>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'CustomPagination',
  props: {
    totalRecords: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    chunk: { // How many page buttons to show
      type: Number,
      default: 100
    }
  },
  computed: {
    lastPage () {
      return Math.ceil(this.totalRecords / this.perPage) || 1
    },
    pages () {
      if (!this.totalRecords) return []

      let pages = []
      const halfChunk = Math.floor(this.chunk / 2)
      let startPage = this.currentPage - halfChunk
      let endPage = this.currentPage + halfChunk

      if (startPage < 1) {
        startPage = 1
        endPage = Math.min(this.lastPage, this.chunk)
      }

      if (endPage > this.lastPage) {
        endPage = this.lastPage
        startPage = Math.max(1, this.lastPage - this.chunk + 1)
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }

      return pages
    },
    isOnFirstPage () {
      return this.currentPage === 1
    },
    isOnLastPage () {
      return this.currentPage === this.lastPage
    },
    from () {
      return (this.currentPage - 1) * this.perPage + 1
    },
    to () {
      let to = this.currentPage * this.perPage
      return Math.min(to, this.totalRecords)
    }
  },
  methods: {
    setPage (page) {
      if (page < 1 || page > this.lastPage || page === this.currentPage) {
        return
      }
      this.$emit('update:currentPage', page)
    },
    formatNumberWithCommas (num) {
      if (num === null || num === undefined) {
        return ''
      }
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
.VuePagination {
  display: flex;
  justify-content: flex-start; // Changed to flex-start
  align-items: flex-start; // Changed to flex-start
  margin-top: 15px;

  nav {
    display: flex;
    flex-direction: column;
    align-items: flex-start; // Changed to flex-start
  }

  ul.pagination {
    display: flex;
    flex-wrap: wrap; // Added for wrapping
    gap: 5px; // Added for spacing between items
    padding-left: 0;
    list-style: none;
  }

  .page-item {
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    background-color: transparent; // Added
    border: none; // Added
    outline: none; // Added to prevent outline on focus

    &.disabled {
      .page-link {
        color: #9e9e9e;
        pointer-events: none;
        cursor: not-allowed;
        background-color: #f5f5f5;
        border-color: #e0e0e0;
      }
    }
    &.active {
      .page-link {
        z-index: 1;
        color: #ffffff;
        background-color: #31B9B7;
        border-color: #31B9B7;
      }
      &.prev-next-item .page-link { // For active prev/next buttons
        color: #000000; // Text color to black when active
      }
    }
  }

  .page-link {
    position: relative;
    display: flex; // Changed to flex for better centering
    justify-content: center; // Horizontal centering
    align-items: center; // Vertical centering
    padding: .5rem .75rem;
    margin-left: 0;
    line-height: 1; // Set line-height to 1 for vertical centering with flexbox
    color: #212121;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    text-decoration: none;
    min-width: 38px;
    height: 38px;
    text-align: center;
    border-radius: 4px;

    &:hover {
      z-index: 2;
      color: #212121;
      background-color: #f5f5f5;
      border-color: #e0e0e0;
      cursor: pointer;
    }

    &.prev-next-btn {
      border: none; // Remove border for prev/next
      background-color: transparent; // Make background transparent
      box-shadow: none; // Ensure no shadow
      color: #31B9B7; // Color for prev/next
      font-weight: bold; // Make them bold
      &:hover {
        background-color: #e0e0e0; // Light grey on hover
      }
    }
  }

  // Explicitly set background for inactive prev/next buttons
  .page-item:not(.active):not(.disabled) .page-link.prev-next-btn {
    background-color: transparent;
  }

  .VuePagination__count {
    margin-top: 5px;
    font-size: 0.9em;
    color: #000000; // Changed to black
    text-align: left; // Added to explicitly left-align the count text
  }
}
</style>
